import React from 'react';
import {Input, Modal} from '../../../../components';
import {StyledIconClose} from './ModalInformation.style';
import {Box, DialogContent, Typography} from '@mui/material';
import {images} from '../../../../constants/image';
import colors from '../../../../theme/colors';

interface ModalInformationProps {
  visible: boolean;
  onClose: (e: any) => void;
  data: {
    variant: string;
    data: any;
  };
}

const ModalInformation = (props: ModalInformationProps) => {
  const {visible, onClose, data} = props;
  const {variant, data: informationData} = data || {};

  const renderRow = (title: string, content: string) => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="subtitle2" mb={2}>
        {title}
      </Typography>
      <Input
        type="text"
        size="small"
        variant="outlined"
        value={content}
        readOnly
      />
    </Box>
  );
  return (
    <Modal visible={visible} maxWidth="sm">
      <>
        <StyledIconClose onClick={onClose}>
          <img src={images.icon_close} />
        </StyledIconClose>
        <DialogContent
          sx={{
            mt: 16,
          }}
        >
          <Typography
            fontSize={20}
            fontWeight={450}
            color={colors.coolGrey[100]}
            textAlign="center"
            mb={4}
          >
            {variant &&
              {
                showExclusiveBannerData:
                  'Exclusive banner displayed to targeted member(s) on B2C platforms',
                showPushedNotificationData:
                  'Push Notification sent to opted-in members',
              }[variant]}
          </Typography>
          {variant === 'showExclusiveBannerData' && (
            <>
              {renderRow(
                'Description',
                informationData.showExclusiveB2CBannerText
              )}
              {renderRow(
                'Call to Action Copy',
                informationData.showExclusiveB2CBannerCta
              )}
              {renderRow('Link URL', informationData.showExclusiveB2CBannerUrl)}
            </>
          )}
          {variant === 'showPushedNotificationData' && (
            <>
              {renderRow(
                'Push notification title',
                informationData.pushNotificationTitle
              )}
              {renderRow(
                'Push notification description',
                informationData.pushNotificationText
              )}
            </>
          )}
        </DialogContent>
      </>
    </Modal>
  );
};

export default ModalInformation;
